module.exports = __webpack_public_path__ + "img/L1060783.d3ed829d.jpg";